import { DatePicker } from 'antd';
import TextTypography from 'src/app/components/shared/Typography/Text';
import dayjs from 'dayjs';

interface IProps {
  value: string | null;
  onChange: (val: string) => void;
  placeholder: string;
  label: string;
  clasNames?: string;
  isLabel?: boolean;
  dateFormat?: string;
}

const DateSelect = ({
                      value,
                      onChange,
                      placeholder,
                      label,
                      clasNames = '',
                      isLabel = true,
                      dateFormat = "YYYY-MM-DD"
                    }: IProps) => {

  return (
    <div className="w-full">
      {isLabel && (
        <label>
          <TextTypography fontSize={14}>{label}</TextTypography>
        </label>
      )}

      <DatePicker
        className={`h-[36px] w-full ${clasNames}`}
        value={value ? dayjs(value) : null}
        onChange={(date, dateString) => onChange(dateString)}
        placeholder={placeholder}
        format={dateFormat}
      />
    </div>
  );
};

export default DateSelect;
